export default __webpack_public_path__ + "static/media/li.85bfc49d.svg";